"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { SectionHeader } from "fansunited-sports-ui";
import type { FUSportsMatch } from "fansunited-data-layer";
import { LiveMatchCard } from "@/components/matches";
import { usePostData } from "../../context/PostDataContext";
import type { FUSportsMatchWithNativeId } from "@/utilities/data/types";
import { useTenantSettings } from "@/lib/tenant/TenantSettingsProvider";
export interface RelatedMatchesProps {
  /** Maximum number of matches to display */
  maxItems?: number;
  /** Custom container className */
  className?: string;
  /** Whether to show the section header */
  showHeader?: boolean;
  /** Custom title override */
  title?: string;
  /** Localized label for "Related matches" section */
  matchesLabel: string;
}

/**
 * RelatedMatches - Displays related matches from the post context.
 * Shows live match cards with betting odds and live polling.
 * Designed to be placed at the beginning of posts.
 */
export function RelatedMatches(t0) {
  const $ = _c(24);
  const {
    maxItems: t1,
    className: t2,
    showHeader: t3,
    title,
    matchesLabel
  } = t0;
  const maxItems = t1 === undefined ? 3 : t1;
  const className = t2 === undefined ? "mb-8" : t2;
  const showHeader = t3 === undefined ? true : t3;
  const {
    getEntitiesByType
  } = usePostData();
  const {
    hasOdds
  } = useTenantSettings();
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[0] !== className || $[1] !== getEntitiesByType || $[2] !== hasOdds || $[3] !== matchesLabel || $[4] !== maxItems || $[5] !== showHeader || $[6] !== title) {
    t8 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const matches = getEntitiesByType("match").slice(0, maxItems);
      if (matches.length === 0) {
        t8 = null;
        break bb0;
      }
      const sectionTitle = title ?? matchesLabel;
      t6 = className;
      if ($[12] !== sectionTitle || $[13] !== showHeader) {
        t7 = showHeader && <SectionHeader entity={{
          name: sectionTitle,
          styles: {
            typography: {
              name: "text-sm uppercase font-semibold text-foreground"
            }
          }
        }} styles={{
          container: "mb-4"
        }} />;
        $[12] = sectionTitle;
        $[13] = showHeader;
        $[14] = t7;
      } else {
        t7 = $[14];
      }
      t4 = "space-y-4";
      let t9;
      if ($[15] !== hasOdds) {
        t9 = entity => {
          const match = entity.data as FUSportsMatch;
          const matchWithNativeId = {
            ...match,
            fansUnitedMatchId: entity.entityId
          };
          return <LiveMatchCard key={entity.entityId} match={matchWithNativeId} variant="embedded" showOdds={hasOdds} />;
        };
        $[15] = hasOdds;
        $[16] = t9;
      } else {
        t9 = $[16];
      }
      t5 = matches.map(t9);
    }
    $[0] = className;
    $[1] = getEntitiesByType;
    $[2] = hasOdds;
    $[3] = matchesLabel;
    $[4] = maxItems;
    $[5] = showHeader;
    $[6] = title;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t4 = $[7];
    t5 = $[8];
    t6 = $[9];
    t7 = $[10];
    t8 = $[11];
  }
  if (t8 !== Symbol.for("react.early_return_sentinel")) {
    return t8;
  }
  let t9;
  if ($[17] !== t4 || $[18] !== t5) {
    t9 = <div className={t4}>{t5}</div>;
    $[17] = t4;
    $[18] = t5;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t6 || $[21] !== t7 || $[22] !== t9) {
    t10 = <section className={t6}>{t7}{t9}</section>;
    $[20] = t6;
    $[21] = t7;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  return t10;
}